import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export interface ExportCampaignPagesStaticUrlsParams {
  id: string;
}

export const exportCampaignPagesStaticUrls = async (
  params: ExportCampaignPagesStaticUrlsParams,
): Promise<Blob> => {
  return await tinctApi.campaigns.exportCampaignPagesStaticUrls(params.id);
};

export const useExportCampaignPagesStaticUrls = (
  options?: Omit<
    UseMutationOptions<Blob, ApiError, ExportCampaignPagesStaticUrlsParams>,
    'mutationFn'
  >,
) => {
  return useMutation({
    mutationFn: exportCampaignPagesStaticUrls,
    ...options,
  });
};
